import React, {memo} from 'react';

import PropTypes from 'prop-types';

function Glyphicon({glyph, className, onClick, style}) {
  return (
    <span
      className={`icon glyphicon ${glyph} ${className}`}
      onClick={onClick}
      style={style}
    />
  );
}

Glyphicon.propTypes = {
  glyph: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  style: PropTypes.object,
};

Glyphicon.defaultProps = {
  glyph: '',
  className: '',
  onClick: () => {},
  style: {},
};

export default memo(Glyphicon);
